import { ActivatedRouteSnapshot, RouterStateSnapshot, CanActivate, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppNavigationService } from '../app-navigation.service';
import { JwtHelperService } from '@auth0/angular-jwt';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AppComponent } from '../app.component';
import { ErrorHandlerModuleService } from 'r2-error-handler-module';

@Injectable()
export class DirectAccessActivateGuardService implements CanActivate {

  constructor(private router: Router, private service: AppNavigationService,
    private errorHandlerService: ErrorHandlerModuleService, private jwtHelper: JwtHelperService) {
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const token = sessionStorage.getItem('mmih_auth_token');
    if (!token || this.jwtHelper.isTokenExpired(token)) {
      sessionStorage.removeItem('mmih_auth_token');
      this.errorHandlerService.openErrorSnackBar('Login expired. Please login again', 1000);
      this.service.redirectToMethub();
      return false;
    } else if (this.router.url === '/' && state.url !== '/payment') {
      this.router.navigate(['/payment']);
      return false;
    }
    return true;
  }
}
